export default __webpack_public_path__ + "static/media/12.2dcbe32e.jpg";